import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Link as StyledLink } from '@material-ui/core';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ConfigContext } from '../../config/index';

function Copyright(props) {
  return (
    <Typography variant="body2" align="center">
      Copyright © {new Date().getFullYear()} {props.siteName}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  footer: {
    background: 'linear-gradient(180deg, #222 0%, #1e1e1e 100%)',
    padding: theme.spacing(6),
    color: '#fff',
    textAlign: 'center',
  },
  links: {
    fontSize: '.75em',
  },
}));

export default function Footer() {
  const classes = useStyles();
  const config = useContext(ConfigContext);

  return (
    <footer className={classes.footer}>
      <p>Most updates happen on Tuesdays or Wednesdays.</p>
      <Typography variant="subtitle1" align="center" component="p">
        <StyledLink component={Link} to="/" className={classes.links}>
          HOME
        </StyledLink>
        {'  -  '}
        <StyledLink
          component={Link}
          to="/contact/form"
          className={classes.links}
        >
          CONTACT
        </StyledLink>
        {'  -  '}
        <StyledLink component={Link} to="/privacy" className={classes.links}>
          PRIVACY POLICY
        </StyledLink>
      </Typography>
      <Copyright siteName={config.siteName} />
    </footer>
  );
}

Copyright.propTypes = {
  siteName: PropTypes.string,
};
